import {Component} from '@angular/core';
import {ViewController, NavParams} from 'ionic-angular';
import {JurisdictionType} from '../../../../../services/jurisdictiontype.service';

@Component({
    template: `
        <ion-list>
            <ion-list-header color="dark">Jurisdictions</ion-list-header>
            <button ion-button full color="light" *ngFor="let x of jurisdictionList" (click)="selectItem(x)">{{x.name}}</button>
        </ion-list>
    `,
})
export class JurisdictionPopover {

    // Declare our preset title list
    private jurisdictionList : JurisdictionType[];

    constructor( 
        public viewCtrl : ViewController,
    ) {
        // Assign our title list to our preset list
        let navParams : NavParams = this.viewCtrl.getNavParams();
        this.jurisdictionList = navParams.get("jurisdictionTypes");
    }
    
    selectItem(item : JurisdictionType) {
        this.viewCtrl.dismiss({
            selected: item
        });
    }
}
    


// WEBPACK FOOTER //
// ./src/pages/report/tab-main/inspection/inspection-popover/jurisdiction-popover.component.ts